The images for the verification button, with different background colours.
